import { Typography } from "@outschool/backpack";
import { useActivityString } from "@outschool/ui-components-website";
import React from "react";

type AgeRangeProps = {
  minAge: number | null;
  maxAge: number | null;
};

export const AgeRange: React.FunctionComponent<AgeRangeProps> = ({
  minAge,
  maxAge
}) => {
  const { ageRangeString } = useActivityString();

  return (
    <Typography
      variant="inherit"
      sx={{
        fontSize: "14px",
        lineHeight: "21px",
        color: "grey.500",
        display: "block"
      }}
    >
      {ageRangeString({ age_max: maxAge, age_min: minAge })}
    </Typography>
  );
};
